module.exports = __webpack_public_path__ + "img/guide_dir_06.8df12902.png";